import React, { FC, useEffect, useState } from "react";
import { MainBudgetPresenter } from "@presenters/screens/main-budget.presenter";
import { IMainBudget } from "@interfaces/screens/main-budget.interface";
import {
  ResumeBudget,
  CsvByCountry,
  CsvByOnCECO,
  CsvByOnPEP,
  AEATabs,
  AEATab,
  IndexBudget,
  FullDetailDataBudget,
} from "@components/";
import MainLayout from "../main-layout/main-layout";

const Budget: FC<any> = () => {
  const [dataColumns, setDataColumns] = useState(null);
  const [dataSource, setDataSource] = useState([]);

  const view: IMainBudget = {
    state: {
      dataSource,
      dataColumns,
      setDataColumns,
      setDataSource,
    },
  };

  const presenter = new MainBudgetPresenter(view);

  //useEffect(() => {
  //  presenter.validateUserInfo();
  //}, [presenter.currentUser]);

  return (
    <MainLayout>
      {presenter.currentLabel ? (
        <AEATabs defaultTab={0}>
          <AEATab title={presenter.currentLabel.get("Índice")} active={true}>
            <IndexBudget></IndexBudget>
          </AEATab>
          <AEATab title={presenter.currentLabel.get("Resumen")} active={false}>
            <ResumeBudget></ResumeBudget>
          </AEATab>
          <AEATab title={presenter.currentLabel.get("Detalle")} active={false}>
            <FullDetailDataBudget></FullDetailDataBudget>
          </AEATab>
          <AEATab
            title={presenter.currentLabel.get("SAP Proyectos")}
            active={false}
          >
            <CsvByCountry></CsvByCountry>
          </AEATab>
          <AEATab
            title={presenter.currentLabel.get("SAP ON CECO")}
            active={false}
          >
            <CsvByOnCECO></CsvByOnCECO>
          </AEATab>
          <AEATab
            title={presenter.currentLabel.get("SAP ON PEP")}
            active={false}
          >
            <CsvByOnPEP></CsvByOnPEP>
          </AEATab>
        </AEATabs>
      ) : (
        <div></div>
      )}
    </MainLayout>
  );
};
export default Budget;
